export default __webpack_public_path__ + "static/media/galoswap logo-02.1b249493.png";